import * as React from 'react';
import {Button} from 'react-bootstrap';

const RegistrationStepper = ({steps, activeStep, children}) => {

    return (
        <>
            <div className='d-flex justify-content-center'>
                {steps.map(step => {
                    if (steps[activeStep] === step) {
                        return <Button key={step} variant='info' disabled>
                            {step}
                        </Button>;
                    } else {
                        return <Button key={step} variant='secondary' disabled>
                            {step}
                        </Button>;
                    }
                })}
                    </div>
                    <div>
                {children}
                    </div>
                    </>
                    );
                };

                export default RegistrationStepper;